import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Intro from "../../elements/blocks/intro";
import AudienceForm from "../../elements/campaigns/audience/audience-form";
import AudienceDelete from "../../elements/campaigns/audience/audience-delete";
import Nope from "../../elements/blocks/nope";
import { useApiTenant } from "../../../api/api-tenant";
import { useRoles } from "../../../services/roles";
export default function AudienceEdit() {
    const { t } = useTranslation();
    const { campaignId, audienceId } = useParams();
    const api = useApiTenant();
    const roles = useRoles();
    const [isLoading, setIsLoading] = useState(true);
    const [audience, setAudience] = useState(null);
    useEffect(() => {
        api.GET_audience(audienceId, campaignId)
            .then(response => {
            setAudience(response.data.audience);
            setIsLoading(false);
        })
            .catch(error => {
            if (!api.isCancel(error)) {
                console.error(error);
                setIsLoading(false);
            }
        });
        return () => api.cancel();
    }, []);
    return (_jsxs(Fragment, { children: [_jsx(Intro, { name: audience ? audience.name : t("campaigns.audiences.audience") + " #" + audienceId, breadcrumbs: [
                    {
                        name: t("campaigns.campaigns"),
                        link: "/campaigns",
                    },
                    {
                        name: audience ? audience.campaign.name : t("campaigns.campaign"),
                        link: "/campaigns/" + campaignId,
                    },
                    {
                        name: audience ? audience.name : t("campaigns.audiences.audience"),
                        link: "/campaigns/" + campaignId + "/audiences/" + audienceId,
                    },
                    {
                        name: t("campaigns.audiences.edit-audience"),
                        link: "/campaigns/" + campaignId + "/audiences/" + audienceId + "/edit",
                    },
                ], loading: isLoading }), isLoading ? (_jsx(Fragment, {})) : audience ? (_jsxs(Fragment, { children: [_jsx(AudienceForm, { campaignId: campaignId, status: "edit", audience: audience }), (roles.isAdmin || roles.isManager) && _jsx(AudienceDelete, { audience: audience })] })) : (_jsx(Nope, { title: t("errors.404"), caption: t("campaigns.audiences.not-found") }))] }));
}
